import { getErrorCode, getErrorArguments, isApiErrorWithResponse } from '@api/apiClient';
import { isAdmin } from '@utils/auth';

export function getErrorMessage({ errorPrefix, error, defaultError, context, t }: {
  errorPrefix?: string,
  defaultError?: string,
  error: any,
  context?: Record<string, string | ((data: Record<string, string>) => string)>,
  t: (v: string, params?: any) => string,
}) {
  // const { t } = useTranslation();
  const prefix = errorPrefix ?? "apiErrors";
  const isThisAdmin = isAdmin();

  let errorMessage = t(
    `${prefix}.default${isThisAdmin ? "-isAdmin" : ""}`,
    { defaultValue: t(defaultError ?? "defaultFormErrors.default") },
  );
  if (isApiErrorWithResponse(error)) {
    const args = getErrorArguments(error);
    const stringArgs = Object.keys(context ?? {})
      .reduce((acc: Record<string, string>, key: string) => {
        const item = context?.[key] ?? "";
        acc[key] = String(typeof item === "function" ? item(args) : item);
        return acc;
      }, {} as Record<string, string>);
    errorMessage = t(
      `${prefix}.${getErrorCode(error, "")}`,
      {
        defaultValue: errorMessage,
        ...args,
        ...stringArgs,
      },
    );
  } else if (typeof error === "string") {
    errorMessage = error;
  }

  return errorMessage;
}
